import { deepEqual } from '@/utils/object-util'

/**
 * Quote for a job.
 */
export interface Quote {
  /**
   * Line items.
   */
  items: QuoteLineItem[]

  /**
   * The quoted price, if visible.
   */
  price: QuotedPrice | null
}

/**
 * Quoted price, if visible to the user.
 */
export interface QuotedPrice {
  /**
   * Primary amount.
   */
  primaryAmount: number
  /**
   * Amount due up-front.
   */
  upfrontAmount: number
  /**
   * Applied discount, if any.
   */
  discount: AppliedDiscount | null
  /**
   * Total quoted amount.
   */
  total: number
}

/**
 * Describes an applied discount.
 */
export interface AppliedDiscount {
  /**
   * Coupon ID.
   */
  couponId: string
  /**
   * Coupon code.
   */
  couponCode: string
  /**
   * Discount amount.
   */
  amount: number
}

/**
 * Line item on the quote.
 */
export interface QuoteLineItem {
  /**
   * Name of the item.
   */
  name: string
}

export const Quote = {
  /**
   * Checks whether 2 quotes are equal.
   *
   * @param left
   * @param right
   */
  equals(left: Quote | null, right: Quote | null) {
    if (left === right) {
      return true
    }

    // Quick check for null on both sides.
    if (!!left !== !!right) {
      return false
    }

    return deepEqual(left, right)
  },
}
